// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"I3-z","displaySixCardTiles":"J3-z"};